<template>
  <qc-container title="收货信息" show-divider show-return>
    <el-descriptions v-if="order" :column="1" border>
      <el-descriptions-item v-if="order.deliveryName" label-class-name="w100"  label="收货人">{{order.deliveryName}}&nbsp;&nbsp;{{order.mobile}}&nbsp;&nbsp;{{order.address}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="收货方式">{{order.groupType==1?"自提":"快递"}}</el-descriptions-item>
      <template v-if="order.express">
        <el-descriptions-item label-class-name="w100" label="物流公司">{{order.expressDesc}}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="快递单号">{{order.expressCode}}<span class="ml10 cp primary" @click="copyText(order.expressCode)">复制</span></el-descriptions-item>
      </template>
    </el-descriptions>
  </qc-container>
  <qc-container v-if="order" title="订单信息" class="mt20">
      <el-descriptions  :column="2" border>
        <el-descriptions-item label-class-name="w100" label="订单编号">{{order.code}}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="下单时间">{{order.createTime}}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="买家名称">{{order.nickname}}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="买家手机号">{{order.phone}}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="状态">{{getOrderStatus(order)}}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="订单类型">{{['售卖','租赁','洗消'][order.goodsType]}}</el-descriptions-item>
        <el-descriptions-item v-if="order.closeTime" label-class-name="w100" label="关闭时间">{{order.closeTime}}</el-descriptions-item>
        <template v-if="order.payTime">
          <el-descriptions-item label-class-name="w100" label="支付方式">{{['微信支付','支付宝'][order.payType]}}</el-descriptions-item>
          <el-descriptions-item label-class-name="w100" label="支付时间">{{order.payTime}}</el-descriptions-item>
        </template>
        <el-descriptions-item v-if="order.goodsType===1" label-class-name="w100" label="租赁合同">
          <span class="primary cp" @click="openOrderContract">《用户租赁合同》</span>
          <open-contract ref="openContract"></open-contract>
        </el-descriptions-item>

        <template v-if="order.groupType===0">
          <el-descriptions-item v-if="order.deliverTime" label-class-name="w100" label="发货时间">{{order.deliverTime}}</el-descriptions-item>
          <el-descriptions-item v-if="order.receiveTime" label-class-name="w100" label="收货时间">{{order.receiveTime}}</el-descriptions-item>
        </template>
        <template v-if="order.groupType===1">
          <el-descriptions-item v-if="order.deliverTime"  label-class-name="w100" label="核销时间">{{order.deliverTime}}</el-descriptions-item>
        </template>
        <el-descriptions-item v-if="order.orderGoodsList[0].leaseStartTime" label-class-name="w100" label="开始时间">{{order.orderGoodsList[0].leaseStartTime}}</el-descriptions-item>
        <el-descriptions-item v-if="order.orderGoodsList[0].leaseEndTime" label-class-name="w100" label="结束时间">{{order.orderGoodsList[0].leaseEndTime}}</el-descriptions-item>

        <el-descriptions-item v-if="order.returnTime" label-class-name="w100" label="归还时间">{{order.returnTime}}</el-descriptions-item>
        <el-descriptions-item v-if="order.beforeReturnMoney" label-class-name="w100" label="提前归还退款">￥{{order.beforeReturnMoney}}</el-descriptions-item>
        <el-descriptions-item v-if="order.recycleTime" label-class-name="w100" label="回收时间">{{order.recycleTime}}</el-descriptions-item>
        <el-descriptions-item v-if="order.commentTime" label-class-name="w100" label="完成时间">{{order.commentTime}}</el-descriptions-item>
        <el-descriptions-item v-if="order.remarks" label-class-name="w100" label="备注">{{order.remarks}}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions class="mt20" v-if="order.recycleTime" title="回收情况" :column="1" border>
        <el-descriptions-item label-class-name="w100" label="是否存在损坏">{{order.recycleMoney?`赔付金额${order.recycleMoney}元`:"否"}}</el-descriptions-item>
        <el-descriptions-item label-class-name="w100" label="回收说明">
          {{order.recycleContent}}
          <image-show v-if="order.recyclePicList&&order.recyclePicList.length>0"  :images="order.recyclePicList.map(item=>filePath+item.url)"></image-show>
        </el-descriptions-item>
      </el-descriptions>

    <el-descriptions class="mt20" v-if="order.orderRelative" title="亲友信息" :column="2" border>
      <el-descriptions-item label-class-name="w100" label="名称">{{order.orderRelative.name}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="性别">{{order.orderRelative.genderDesc}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="年龄">{{order.orderRelative.age}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="关系">{{order.orderRelative.relationshipTypeDesc}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="联系电话">{{order.orderRelative.mobile}}</el-descriptions-item>

    </el-descriptions>
      <t-table class="mt20" border :header="tableHeader" :data="order.orderGoodsList">
        <template #before>
          <el-table-column label="商品名称" >
            <template #default="scope">
              <div class="goods-tag">
                <img class="table-img" :src="filePath+scope.row.picture">
                <div class="flex-1 ml20">
                  <div class="bold">{{ scope.row.name}}</div>
                  <div>编号:{{ scope.row.code}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </template>
      </t-table>
      <div class="sumMoney">
        <div><strong>商品总价：</strong>￥{{order.money}}</div>
        <div v-if="order.freight"><strong>运费：</strong>￥{{order.freight || 0}} </div>
        <div v-if="order.discount"><strong>优惠：</strong>￥{{order.discount || 0}} </div>
        <div v-if="order.goodsType===1&&order.integralNum >0"><strong>租赁押金：</strong>￥{{order.integralNum || 0}} </div>
        <div><strong>订单金额：</strong><span class="primary">￥{{order.payMoney}} </span></div>
        <div v-if='order.sumRenewalMoney'><strong>续费金额：</strong><span class="primary">￥{{order.sumRenewalMoney}} </span></div>
        <div><strong>合计：</strong><span class="primary">￥{{getSumMoney(order.payMoney,order.sumRenewalMoney)}} </span></div>
      </div>
      <return-box></return-box>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import TTable from "@/components/el/t-table.vue";
import ReturnBox from "@/components/home/return-box.vue";
import ImageShow from "@/components/base/image-show.vue";
import OpenContract from "@view/lease/contract/open-contract.vue";

export default {
  name: "order-detail",
  components: {OpenContract, ImageShow, ReturnBox, TTable, QcContainer},
  data() {
    return {
      order:null,
      tableHeader: [
        {label: "属性",width: 300,renderDraw:row=>{
            let content = row.property+"";
            if(this.order.goodsType===1){
              content += ";&nbsp;&nbsp;租用:"+row.leaseDay+"天";
            }
            return content;
          }},
        {prop: "money", label: "单价",width:100},
        {prop: "count", label: "数量",width:100},
        {prop: "sumMoney", label: "合计",width:100}
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    getSumMoney(m1,m2){
      return this.numAdd(m1||0,m2||0);
    },
    openOrderContract(){
      this.simplePost("/api/mgr/shop/business/order/getUserContract",{orderId:this.order.id},res=>{
        this.$refs.openContract.open(res.data);
      })
    }
  },
  mounted() {
      if (this.$route.query && this.$route.query.id) {
          this.simpleGet("/api/mgr/shop/business/order/detail", {id: this.$route.query.id}, result => {
              this.order = result.data;
          });
      }
  }
}
</script>


<style lang="less" scoped>
.goods-tag{
  display: flex;
  .flex-1 div{
    line-height: 18px;
  }
}
.table-img{
  width: 50px;
  height:50px;
}
.sumMoney{
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  div{
    line-height: 40px;
  }
}
</style>
